// areas/settings/survey-question/api/surveyQuestionApi.ts
import { adminApi } from '../../../../store/generated/admin/survey_question';

export type StatusEd2Enum = 1 | 2 | 3;
export type SurveyTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

const SurveyQuestionApiTags = {
  SurveyQuestion: 'SurveyQuestion',
};

export const surveyQuestionApi = adminApi.enhanceEndpoints({
  addTagTypes: [SurveyQuestionApiTags.SurveyQuestion],
  endpoints: {
    apiAdminV1SurveyQuestionCreate: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestion],
    },
    apiAdminV1SurveyQuestionDestroy: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestion],
    },
    apiAdminV1SurveyQuestionList: {
      providesTags: (result = []) =>
        result.map(cat => ({ type: SurveyQuestionApiTags.SurveyQuestion, id: cat.id })),
    },
    apiAdminV1SurveyQuestionRetrieve: {
      providesTags: (result, error, arg) => [
        { type: SurveyQuestionApiTags.SurveyQuestion, id: arg.id },
      ],
    },
    apiAdminV1SurveyQuestionUpdate: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestion],
    },
    apiAdminV1SurveyQuestionDuplicateCreate: {
      invalidatesTags: [SurveyQuestionApiTags.SurveyQuestion],
    }
  }
})

